<!-- Error page. Nuxt requires it to be a layout, but it behaves like a page -->
<template>
  <v-container
    fluid
    fill-height
  >
    <v-row>
      <v-row justify="center">
        <div id="applicationError">
          <v-img
            src="/src/images/error.svg"
            max-width="400px"
          />
          <div class="headline mt-5 text-center">
            Chyba {{ error.statusCode }}
          </div>
          <div
            id="applicationErrorMessage"
            class="headline mt-1 text-center"
          >
            {{ error.message }}
          </div>
        </div>
      </v-row>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    error: { // Object containing error info
      type: Object,
      default: () => ({statusCode: 0, message: ''}),
      validator: (val) => {
        // statusCode and message are required
        return !!val.statusCode && !!val.message
      }
    }
  },
  head() {
    return {
      title: `Chyba ${this.error.statusCode}`
    }
  }
}
</script>
